import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { Box, Container, Grid, Typography, Card, Button, Alert } from '@mui/material';
import { ThemeProvider, createTheme } from '@mui/material/styles';

// Crear tema personalizado con el color Pantone 1805 de Morena
const theme = createTheme({
  palette: {
    primary: {
      main: '#AF272F', // Pantone 1805 - Color oficial de Morena
      light: '#CC5A61',
      dark: '#8B1F27',
      contrastText: '#ffffff',
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <App />
    </ThemeProvider>
  </React.StrictMode>
);

// Usar Box, Container y Grid para responsividad
// Typography con variant responsive
// Ajustar Card, Button, Alert, etc. con sx={{ width: '100%', maxWidth: 600, mx: 'auto', px: { xs: 1, sm: 2 }, py: { xs: 2, sm: 3 } }}

// Desregistrar service worker y limpiar caché
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.getRegistrations().then(registrations => {
    registrations.forEach(r => r.unregister());
  });
  caches.keys().then(keys => keys.forEach(k => caches.delete(k)));
}
